// extracted by mini-css-extract-plugin
export default {"productList":"add-shipment-modal_productList__T8et7","selectorWrapper":"add-shipment-modal_selectorWrapper__pWn7I"};